/**
 * Created by jv on 20/07/2017.
 */
const utils = require("Sources/utils/utils");
const Tooltip = require("Sources/components/tooltip");
const log = require("Sources/utils/logger")();

module.exports = class FormValidator {
  constructor(options) {
    if (utils.isNull(options)) {
      throw "options must be defined";
    }

    this.selector = $(options.selector);
    // Rules either come from javascript in this property or from data attributes
    // eg. data-fv-required="true" data-fv-min-length="6" data-fv-max-length="30" data-fv-same-as="something"
    // if both are present then rules from javascript take priority
    this.rules = options.rules;

    this.errorClassName = utils.isNullOrEmpty(options.errorClassName) ? "is-invalid" : options.errorClassName;

    this.validateOnChange = utils.isBoolean(options.validateOnChange) ? options.validateOnChange : false;
    this.onValidateElement = options.onValidateElement;

    this.hasChangedValues = false;

    this.init();
  }

  init() {
    let that = this;

    that.selector.find("input, textarea").on("input", function (e) {
      let $el = $(this);
      $el.removeClass(that.errorClassName);
      if (utils.isNotNull(that.rules.tooltip)) {
        Tooltip.dispose({selector: $el});// %NOTE: maybe better to enable/disable instead of create/destroy?
      }
    });

    that.selector.find("select").on("change", function (e) {
      let $el = $(this);
      $el.removeClass(that.errorClassName);
      if (utils.isNotNull(that.rules.tooltip)) {
        Tooltip.dispose({selector: $el});// %NOTE: maybe better to enable/disable instead of create/destroy?
      }
    });

    that.selector.find("input, textarea, select").on("change", function (e) {
      let $el = $(this);
      let name = $el.data("fv-name") || $el.attr("id");

      let elRules = null;

      if (utils.isNotNull(name) && utils.isNotNull(that.rules) && that.rules.hasOwnProperty(name)) {
        elRules = that.rules[name];
      }

      let validateOnChange = that.validateOnChange;

      if (utils.isNotNull(elRules)) {
        validateOnChange = (that.validateOnChange && elRules.validateOnChange !== false) || elRules.validateOnChange;
      }

      if (validateOnChange) {
        let isValid = FormValidator.validateElement($el, that.errorClassName, elRules);

        if (utils.isFunction(that.onValidateElement)) {
          that.onValidateElement($el, isValid);
        }
      }

      that.hasChangedValues = true;
    });
  }

  clearForm() {
    this.selector.find("input, select, textarea").each(function (index, el) {
      let $el = $(el);
      let name = $el.data("fv-name") || $el.attr("id");
      let tagName = $el.prop("tagName").toLowerCase();
      let type = tagName === "input" ? $el.attr("type") : tagName;

      if ($el.data("fv-ignore") === true || type === "hidden" || utils.isNullOrEmpty(name)) {
        return true;
      }

      $el.val("");
    });
  }

  setValueForKey(key, value, options) {
    options = utils.isNotNull(options) ? options : {};

    let $el = this.selector.find("[data-fv-name='" + key + "']");

    if (utils.isNull($el) || !$el.length) {
      $el = this.selector.find("#" + key);
    }

    if (utils.isNotNull($el) && $el.length) {
      let tagName = $el.prop("tagName").toLowerCase();
      let type = tagName === "input" ? $el.attr("type") : tagName;

      if ($el.length > 0 && utils.isNotNull($el[0].selectize)) {
        $el[0].selectize.setValue(value, true);
      } else if (type === "checkbox") {
        $el.prop("checked", value);
      } else {

        $el.val(value);
      }

      if (options.markAsChanged) {
        this.hasChangedValues = true;
      }

      if (options.triggerChangeEvent) {
        $el.trigger("change");
      }

      return $el;
    } else {
      return null;
    }
  }

  setValid(key, flag) {
    let $el = this.selector.find("[data-fv-name='" + key + "']");

    if (utils.isNull($el) || !$el.length) {
      $el = this.selector.find("#" + key);
    }

    if (utils.isNotNull($el) && $el.length) {
      if (utils.isNull(flag)) {
        $el.removeClass("is-invalid").removeClass("is-valid");
      }

      if (flag) {
        $el.removeClass("is-invalid").addClass("is-valid");
      } else {
        $el.removeClass("is-valid").addClass("is-invalid");
      }
    }
  }

  validate() {
    let that = this;
    let isValid = true;

    this.selector.find("input, textarea, select").each(function (index, el) {
      let $el = $(el);

      let name = $el.data("fv-name") || $el.attr("id");

      let elRules = null;

      if (utils.isNotNull(name) && utils.isNotNull(that.rules) && that.rules.hasOwnProperty(name)) {
        elRules = that.rules[name];
      }

      let formElValid = FormValidator.validateElement($el, that.errorClassName, elRules);

      // log.info("%s is %s for rules %o", name, (formElValid ? "valid" : "not valid"), elRules);
      if (utils.isFunction(that.onValidateElement)) {
        that.onValidateElement($el, formElValid);
      }

      isValid = isValid && formElValid;
    });

    return isValid;
  }

  static validateElement(selector, errorClassName, rules) {
    let $el = $(selector).removeClass(errorClassName);
    let name = $el.data("fv-name") || $el.attr("id");
    rules = utils.isNotNull(rules) ? rules : {};

    if (utils.isNotNull(rules.tooltip)) {
      Tooltip.dispose({selector: $el});
    }

    let isValid = true;

    let tagName = $el.prop("tagName").toLowerCase();
    let type = tagName === "input" ? $el.attr("type") : tagName;
    let value = $el.val();
    let required = utils.isBoolean(rules.required) ? rules.required : $el.data("fv-required") || false;
    let minLength = utils.isDefined(rules.minLength) ? rules.minLength : $el.data("fv-min-length");
    let maxLength = utils.isDefined(rules.maxLength) ? rules.maxLength : $el.data("fv-max-length");
    let minVal = utils.isDefined(rules.minVal) ? rules.minVal : $el.data("fv-min-val");
    let maxVal = utils.isDefined(rules.maxVal) ? rules.maxVal : $el.data("fv-max-val");
    let sameAs = utils.isDefined(rules.sameAs) ? rules.sameAs : $el.data("fv-same-as");
    let validateFunc = rules.validator;
    let trim = rules.trim === true;

    if ($el.data("fv-ignore") === true || type === "hidden") {
      return isValid;
    }

    let formElInfo = {
      tagName,
      type: type,
      value: value,
      required: required,
      minLength: minLength,
      maxLength: maxLength,
      minVal: minVal,
      maxVal: maxVal,
      sameAs,
      validator: validateFunc,
      trim
    };

    log.cssLog("%c%s%c form element info: %o", name, formElInfo, log.infoCss);

    if (utils.isNotNull(value) && trim) value = value.trim();

    if (utils.isNullOrEmpty(value)) {
      if (required) {
        log.cssLog("%s is not valid because the value is required and value is [%s]", name, value, log.errorCss);
        isValid = false;
      }
    } else {
      if (type === "number") {
        value = utils.stringToInt(value);
      }

      if (isValid && type === "number" && !utils.isNumber(value)) {
        log.cssLog("%s is not valid because type is number and [%s] is not a number", name, value, log.errorCss);
        isValid = false;
      }

      if (tagName === "input" || tagName === "textarea") {
        if (type === "number") {
          if (isValid && utils.isNumber(minVal)) {
            if (value < minVal) {
              log.cssLog("%s is not valid because value [%s] is less than the min-val (%s)", name, value, minVal, log.errorCss);
              isValid = false;
            }
          }

          if (isValid && utils.isNumber(maxVal)) {
            if (value > maxVal) {
              log.cssLog("%s is not valid because value [%s] is more than the max-val (%s)", name, value, maxVal, log.errorCss);
              isValid = false;
            }
          }
        } else {
          if (isValid && utils.isNumber(minLength)) {
            if (value.length < minLength) {
              log.cssLog("%s is not valid because the length [%s] of value [%s] is less than the min-length (%s)", name, value.length, value, minLength, log.errorCss);
              isValid = false;
            }
          }

          if (isValid && utils.isNumber(maxLength)) {
            if (value.length > maxLength) {
              log.cssLog("%s is not valid because the length [%s] of value [%s] is greater than the max-length (%s)", name, value.length, value, maxLength, log.errorCss);
              isValid = false;
            }
          }
        }
      }

      if (isValid && type === "email" && !utils.isValidEmail(value)) {
        log.cssLog("%s is not valid because type is email and [%s] is not a valid email", name, value, log.errorCss);
        isValid = false;
      }

      if (isValid && utils.isNotNull(sameAs)) {
        let sameAsEl = $("[data-fv-name='" + sameAs + "']");
        let sameAsValue;

        if (utils.isNotNull(sameAs) && sameAs.length) {
          sameAsValue = sameAsEl.val();
        } else {
          sameAs = $(sameAs);

          if (utils.isNotNull(sameAs) && sameAs.length) {
            sameAsValue = sameAsEl.val();
          }
        }

        if (value !== sameAsValue) {
          log.cssLog("%s is not valid because value [%s] is not the same as value [%s] from %s", name, value, sameAsValue, sameAs, log.errorCss);
          isValid = false;
        }
      }
    }

    if (isValid && utils.isFunction(validateFunc)) {
      if (!validateFunc(value)) {
        log.cssLog("%s is not valid because custom validator function did not return true for value [%s]", name, value, log.errorCss);
        isValid = false;
      }
    }

    if (isValid) {
      log.cssLog("%s is valid with value [%s] for form element %o", name, value, formElInfo, log.successCss);
    } else {
      if (!$el.hasClass(errorClassName)) {
        $el.addClass(errorClassName);
      }

      if (utils.isNotNull(rules.tooltip)) // %NOTE: maybe better to enable/disable instead of create/destroy?
      {
        Tooltip.create({
          selector: $el,
          content: rules.tooltip,
          placement: utils.isNullOrEmpty(rules.tooltipPlacement) ? "top" : rules.tooltipPlacement
        });
      }
    }

    return isValid;
  }

  getFormData() {
    let formData = {};

    this.selector.find("input, select, textarea").each(function (index, el) {
      let $el = $(el);
      let name = $el.data("fv-name") || $el.attr("id");
      let tagName = $el.prop("tagName").toLowerCase();
      let type = tagName === "input" ? $el.attr("type") : tagName;

      if ($el.data("fv-ignore") === true || type === "hidden") {
        return true;
      } else if (type === "checkbox") {
        formData[name] = $el.prop("checked");
      } else {
        formData[name] = $el.val();
      }
    });

    return formData;
  }
};



// WEBPACK FOOTER //
// ./app/js/components/form-validator.js